<template>
  <div class="login-wrap">
    <Header></Header>
    <div class="content">
      <div class="title">{{ infoObj[curType].title }}</div>

      <div v-if="curType === 'login'">
        <div class="navs display-flex align-items-center">
          <div class="nav" v-for="nav in navs" :key="nav.key" @click="changeNav(nav)"
               :class="nav.key === curNav ? 'active' : ''">
            {{ nav.value }}
          </div>
        </div>
        <div class="email" @click="openEmailDlg">
          <span>邮箱账号</span>
          <van-icon name="warning-o"/>
        </div>
        <van-form class="form" @submit="onSubmit">
          <van-field v-model="loginFormData.username" label="账号" placeholder="手机号" maxlength="11" required
                     name="validMobile" class="form-first" :rules="[{ validator: validMobile }]"/>
          <van-field v-model="loginFormData.password" label="密码" placeholder="密码" type="password" required
                     name="validPassword" :rules="[{ validator: validPassword }]" v-if="curNav === 1"/>
          <van-field v-model="loginFormData.code" label="短信验证码" placeholder="短信验证码" maxlength="6" required
                     name="validCode" :rules="[{ validator: validCode }]" v-else>
            <template #button>
              <send-msg :mobile="loginFormData.username" :isH5="true"/>
            </template>
          </van-field>
          <van-field v-model="loginFormData.captcha" label="图形验证码" placeholder="图形验证码" maxlength="4" required
                     name="validCaptcha" class="form-last" :rules="[{ validator: validCaptcha }]">
            <template #button>
              <img :src="captchaImg" height="28" alt="" @click="getCaptcha()"/>
            </template>
          </van-field>
          <div class="agreement display-flex align-items-center">
            <van-checkbox v-model="isChecked" icon-size="16"></van-checkbox>
            我已阅读并同意<span @click="toAgreement('protocol')">《用户协议》</span>及<span
              @click="toAgreement('policy')">《隐私政策》</span>
          </div>
          <van-button round block native-type="submit" class="btn">
            {{ infoObj[curType].btn }}
          </van-button>
        </van-form>
      </div>
      <div v-else class="mt-20 form">
        <van-form @submit="onSubmit">
          <van-field v-model="notLoginFormData.mobile" label="账号" placeholder="手机号" maxlength="11" required
                     name="validMobile" class="form-first" :rules="[{ validator: validMobile }]"/>
          <van-field v-model="notLoginFormData.password" label="密码" placeholder="密码(6-16位)" type="password"
                     required name="validPassword" :rules="[{ validator: validPassword }]"/>
          <van-field v-model="notLoginFormData.repass" label="确认密码" placeholder="确认密码(6-16位)" type="password"
                     required name="validRepassword" :rules="[{ validator: validRepassword }]"/>
          <van-field v-model="notLoginFormData.code" label="短信验证码" placeholder="短信验证码" maxlength="6" required
                     name="validCode" :rules="[{ validator: validCode }]">
            <template #button>
              <send-msg :mobile="notLoginFormData.mobile" :isH5="true"/>
            </template>
          </van-field>
          <van-field v-model="notLoginFormData.captcha" label="图形验证码" placeholder="图形验证码" maxlength="4"
                     required name="validCaptcha" :class="{ 'form-last': curType !== 'register' }"
                     :rules="[{ validator: validCaptcha }]">
            <template #button>
              <img :src="captchaImg" height="28" alt="" @click="getCaptcha()"/>
            </template>
          </van-field>
          <van-field v-model="notLoginFormData.invite_code" label="邀请码" placeholder="邀请码（选填）" class="form-last"
                     v-if="curType === 'register'"/>
          <div class="agreement display-flex align-items-center">
            <van-checkbox v-model="isChecked" icon-size="16"></van-checkbox>
            我已阅读并同意<span @click="toAgreement('protocol')">《用户协议》</span>及<span
              @click="toAgreement('policy')">《隐私政策》</span>
          </div>

          <van-button round block native-type="submit" class="btn">
            {{ infoObj[curType].btn }}
          </van-button>
        </van-form>
      </div>

      <div class="display-flex justify-content-space-between">
        <div v-for="(item, index) in infoObj[curType].skipBtns" :key="index" class="skip" @click="toSkip(item[2])">
          {{ item[0] }}
          <span>{{ item[1] }}</span>
        </div>
      </div>
    </div>
    <div class="footer" v-if="showFooter">
      <div>亿景智联（苏州）科技有限公司</div>
      <a target="_blank" href="https://beian.miit.gov.cn/">
        苏ICP备2023018419号-5
      </a>
    </div>
  </div>
  <email-dialog ref="emailDlg"></email-dialog>
</template>

<script setup>
import {onMounted, ref} from "vue";
import Header from "@/components/mobile/Header.vue";
import SendMsg from "@/components/SendMsg.vue";
import {useRoute, useRouter} from "vue-router";
import {validateMobile} from "@/utils/validate";
import {httpGet, httpPost} from "@/utils/http";
import {setUserToken, removeSessionId} from "@/store/session";
import {ElMessage} from "element-plus";
import EmailDialog from "@/components/mobile/EmailDialog";
import {postUserFindPwd, postUserLogin, postUserRegister} from "@/api/user";

const route = useRoute();
const router = useRouter();
const curType = ref("login");
const infoObj = ref({
  login: {
    title: "登录",
    btn: "立即登录",
    skipBtns: [
      ["没有账号？", "立即注册", "register"],
      ["忘记密码？", "找回密码", "forgetPassword"]
    ]
  },
  register: {
    title: "注册",
    btn: "立即注册",
    skipBtns: [["已有账号？", "立即登录", "login"]]
  },
  forgetPassword: {
    title: "找回密码",
    btn: "重置密码",
    skipBtns: [["想起密码？", "立即登录", "login"]]
  }
});
const navs = [
  {
    key: 1,
    value: "密码登录"
  },
  {
    key: 2,
    value: "验证码登录"
  }
];
const curNav = ref(navs[0].key);
const loginParams = {
  username: "",
  password: "",
  code: "",
  captcha: ""
};
const loginFormData = ref({...loginParams});
const notLoginParams = {
  mobile: "",
  password: "",
  repass: "",
  code: "",
  captcha: "",
  invite_code: router.currentRoute.value.query["invite_code"]
};
const notLoginFormData = ref({...notLoginParams});
const isChecked = ref(false);
const captchaID = ref("");
const captchaImg = ref("");
const emailDlg = ref(null);

const validMobile = (val) => {
  if (!validateMobile(val)) return "请输入正确的手机号码";
};
const validCode = (val) => {
  if (!val) return "请输入短信验证码";
};
const validPassword = (val) => {
  if (!val) return "请输入密码";
  if (val.length < 6 || val.length > 16) return "密码长度应为6-16位";
};
const validRepassword = (val) => {
  if (!val) return "请输入确认密码";
  if (val !== notLoginFormData.value.password)
    return "两次输入密码不一致，请重新输入";
};
const validCaptcha = (val) => {
  if (!val) return "请输入图形验证码";
};
const changeNav = (nav) => {
  curNav.value = nav.key;
  let username = loginFormData.value.username;
  loginFormData.value = {...loginParams};
  loginFormData.value.username = username;
  getCaptcha();
};

const toAgreement = (type) => {
  let obj = {
    protocol: "/user-protocol",
    policy: "/private-policy"
  };
  router.push(obj[type]);
};

const onSubmit = async () => {
  if (!isChecked.value) {
    return ElMessage.error("请勾选用户协议和隐私说明");
  }

  const params = {
    ...((curType.value === "login" ? loginFormData : notLoginFormData).value),
    source: "h5",
    id: captchaID.value,
  };

  try {
    if (curType.value === "login") {
      params.type = curNav.value;
      const res = await postUserLogin(params);
      handleLoginSuccess(res);
    } else if (curType.value === "register") {
      const res = await postUserRegister(params);
      handleRegisterSuccess(res);
    } else {
      delete params.invite_code; // 如果是找回密码需要删除邀请码
      await postUserFindPwd(params);
      handleFindPwdSuccess();
    }
  } catch (e) {
    ElMessage.error(`${curType.value === "login" ? "登录" : curType.value === "register" ? "注册" : "密码重置"}失败：${e.message}`);
    getCaptcha();
  }
};

const handleLoginSuccess = (res) => {
  removeSessionId();
  setUserToken(res.data);
  router.push("/mobile");
};

const handleRegisterSuccess = (res) => {
  removeSessionId();
  setUserToken(res.data);
  ElMessage.success("注册成功，即将跳转到对话主界面...");
  setTimeout(() => {
    router.push("/mobile");
  }, 1000);
};

const handleFindPwdSuccess = () => {
  ElMessage.success("密码重置成功，请重新登录！");
  setTimeout(() => {
    curNav.value = navs[0].key;
    toSkip("login");
  }, 1000);
};

const toSkip = (val) => {
  curType.value = val;
  loginFormData.value = {...loginParams};
  notLoginFormData.value = {...notLoginParams};
  getCaptcha();
};

const getCaptcha = () => {
  httpGet("/api/captcha/get")
      .then((res) => {
        captchaImg.value = res.data?.b64s;
        captchaID.value = res.data?.id;
      })
      .catch((e) => {
        ElMessage.error(e.message || "获取图形验证码失败");
      });
};

const hit = () => {
  httpGet("/api/invite/hits", {code: route.query?.invite_code})
      .then(() => {
      })
      .catch(() => {
      });
};
if (route.query?.invite_code) {
  hit();
}

onMounted(() => {
  if (route.query?.invite_code) {
    curType.value = "register";
    notLoginFormData.value.invite_code = route.query?.invite_code;
  }
  getCaptcha();
});

//获取原窗口的高度
const originalHeight = ref(
    document.documentElement.clientHeight || document.body.clientHeight
);
const showFooter = ref(true);
window.onresize = function () {
  //键盘弹起与隐藏都会引起窗口的高度发生变化
  let resizeHeight =
      document.documentElement.clientHeight || document.body.clientHeight;
  if (resizeHeight < originalHeight.value - 10) {
    //当键盘弹起，在此处操作
    showFooter.value = false;
  } else {
    //当键盘收起，在此处操作
    showFooter.value = true;
  }
};

const openEmailDlg = () => {
  emailDlg.value.open();
};
</script>

<style lang="stylus" scoped>
.login-wrap {
  position: relative;
  width: 100vw;
  height: 100vh !important;
  font-size: 14px;
  background: #F3F4FA;

  .content {
    padding: 42px 25px 0;

    .title {
      margin-top: 30px;
      text-align: center;
      font-weight: 700;
      font-size: 28px;
    }

    .navs {
      box-sizing: border-box;
      width: 100%;
      height: 50px;
      padding: 10px;
      background: #F8F8F8;
      border-radius: 10px;
      margin: 20px 0 10px;

      .nav {
        width: 50%;
        height: 36px;
        line-height: 36px;
        text-align: center;
      }

      .active {
        font-weight: 700;
        background: #fff;
        border-radius: 8px;
      }
    }

    .mt-20 {
      margin-top: 20px;
    }

    .email {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      span {
        color: #0057FF;
        margin-right: 5px;
      }
    }

    .form {
      margin-top: 20px;

      .van-cell {
        align-items: center;

        .van-cell__title, .van-cell__value {
          height: 28px;
        }
      }

      .form-first {
        border-radius: 8px 8px 0 0;
      }

      .form-last {
        border-radius: 0 0 8px 8px;
      }
    }

    .agreement {
      margin-top: 30px;

      .van-checkbox {
        margin-right: 5px;
      }

      span {
        color: #5680FA;
      }
    }

    .btn {
      margin-top: 15px;
      width: 100%;
      height: 40px;
      color: #fff;
      font-size: 16px;
      font-weight: 700;
      background: #369AFE;
      border-radius: 20px;
      text-align: center;
      line-height: 40px;
      border: none;
    }

    .skip {
      margin-top: 15px;
      font-size: 14px;

      span {
        color: #5680FA;
      }
    }
  }

  .footer {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100vw
    padding: 0 0 10px;
    font-size: 12px;
    text-align: center;
  }
}
</style>
